import { render } from "./EditAgentModal.vue?vue&type=template&id=ba4a69e2&scoped=true"
import script from "./EditAgentModal.vue?vue&type=script&lang=js"
export * from "./EditAgentModal.vue?vue&type=script&lang=js"

import "./EditAgentModal.vue?vue&type=style&index=0&id=ba4a69e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4a69e2"]])

export default __exports__